import classes from './Breadcrumb.module.css';
import { useLocation, Link, To } from 'react-router-dom';
import ArrowIcon from 'Components/UI_Library/Icons/ArrowIcon';

type Props = {
    parent: string;
    parentPath: string;
    child: JSX.Element | string;
};

const Breadcrumb = (props: Props) => {
    const calcReturnLink = () => {
        const location = useLocation();
        const from = new URLSearchParams(location.search).get('from');
        const link = { pathname: props.parentPath, search: '' } satisfies To;
        if (from) {
            link.search = `?${from}`;
        }
        return link;
    };
    const returnLink = calcReturnLink();
    return (
        <div className={classes.breadcrumb}>
            <Link to={returnLink} className={`${classes.hideMobile} ${classes.parentLink}`}>
                {props.parent}
            </Link>
            <div className={`${classes.arrow} ${classes.hideMobile}`}>
                <div />
                <div />
            </div>
            <Link to={returnLink}>
                <div className={classes.arrowIcon}>
                    <ArrowIcon colour="white" direction="left" />
                </div>
            </Link>
            {props.child}
        </div>
    );
};

export default Breadcrumb;
